import { sendGroupMemberDB } from '@/scripts/dataBase';
import type {
  ChatGroupGroupId,
  ChatGroupHalfMemberArgs,
  ChatGroupMember,
  ChatGroupMemberArgs,
  ChatGroupMemberId,
  ChatGroupMemberIdArgs,
  ChatGroupMemberParams,
  ChatGroupMemberParamsArgs,
} from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { genChatMembers } from '@/contexts/chat/scripts/hooks/useChatGroup/utils';
import { ActionType } from '@/scripts/dataBase/type';
import request from '@/scripts/request';
import type { MyAxiosResponseData } from '@/scripts/request/types';
import { getAvatar } from '@/scripts/utils/genAvatar';

const DBApis = {
  getMembers(
    group_id: string,
    params: { limit: number; offset: number; include_removed?: boolean }
  ) {
    return sendGroupMemberDB<ChatGroupMember[]>(ActionType.queryGroupMembers, {
      tableName: group_id,
      params: params,
    });
  },
  getMember(group_id: ChatGroupGroupId, arg: ChatGroupMemberId) {
    return sendGroupMemberDB<ChatGroupMember[]>(ActionType.queryGroupMemberByUserId, {
      tableName: group_id,
      params: arg.toString(),
    }).then((res) => res[0]);
  },
  insertMembers(group_id: ChatGroupGroupId, args: ChatGroupMemberParams[]) {
    console.trace('=======================insertMembers', group_id, args);
    return sendGroupMemberDB(ActionType.addGroupMembers, {
      tableName: group_id,
      params: genChatMembers(args),
    });
  },
  removeMembers(group_id: ChatGroupGroupId, arg: ChatGroupMemberId) {
    return sendGroupMemberDB(ActionType.deleteGroupMembers, {
      tableName: group_id,
      params: arg.toString(),
    });
  },
};

export const membersApis = {
  getMembers(params: {
    group_id: string;
    limit: number;
    offset: number;
    include_removed?: boolean;
  }) {
    return DBApis.getMembers(params.group_id, params);
  },
  getMembersByUserId(list: ChatGroupHalfMemberArgs[]) {
    return Promise.all(
      list.map(async ({ id, args }) => {
        const DBArgs: Promise<ChatGroupMember>[] = [];

        const args_ = args.map((arg) => {
          if (typeof arg === 'object') {
            return arg;
          }
          const p = DBApis.getMember(id, arg) as Promise<ChatGroupMember>;
          DBArgs.push(p);
          return p;
        });

        return Object.assign(
          {
            id,
            args: await Promise.all(args_),
          } as ChatGroupMemberArgs,
          {
            DBArgs: await Promise.all(DBArgs),
          }
        );
      })
    );
  },
  insertMembers(list: ChatGroupMemberParamsArgs[]) {
    return Promise.all(list.map(({ id, args }) => DBApis.insertMembers(id, args)));
  },
  removeMembers(list: ChatGroupMemberIdArgs[]) {
    return Promise.all(
      list.map(({ id, args }) =>
        Promise.all(args.map((user_id) => DBApis.removeMembers(id, user_id)))
      )
    );
  },
  getUsersByUserId(ids: string[]) {
    return request<MyAxiosResponseData<{ list: ChatGroupMember[] }>>(
      '/api/v1/user/list',
      {
        method: 'POST',
        data: { ids },
      }
    ).then((res) => {
      res.data.list?.forEach((item) => {
        item.avatar = getAvatar(item.avatar, item.name);
      });
      return res.data.list ?? [];
    });
  },
};
